import { PocButton } from 'commons/components/components-wrapper/poc-button.component';
import { TooltipedElementComponent } from 'commons/components/tooltiped-element';
import { useTranslation } from 'core/i18n';
import { MAX_DIRECTORIES } from 'modules/settings/pods/settings-integrations/settings-integrations-active-directory/settings-integrations-active-directory.constants';

interface ActiveDirectoryTooltipedAddButtonComponentProps {
    disabled: boolean;
    isLimitReached: boolean;
    onClick: VoidFunction;
}

export const ActiveDirectoryTooltipedAddButtonComponent: React.FC<ActiveDirectoryTooltipedAddButtonComponentProps> = ({
    disabled,
    isLimitReached,
    onClick,
}) => {
    const { t } = useTranslation();

    return (
        <TooltipedElementComponent
            hideTooltip={!isLimitReached}
            tooltipText={t('settings.integrations.active-directory.list.add-limit-reached', {
                maxDirectories: MAX_DIRECTORIES,
            })}
        >
            <PocButton
                variant="secondary"
                disabled={disabled}
                onClick={onClick}
                data-testid="active-directory-add-button"
            >
                {t('settings.integrations.active-directory.list.add-button')}
            </PocButton>
        </TooltipedElementComponent>
    );
};
